import ReportDrawer from '../../../constants/ReportDrawer';
import SidebarOpen from '../../../constants/SidebarOpen';
import { useSidebar } from '../../../helpers/sidebarClose';
import CircleBtn from '../../../constants/CircleBtn';
import ReportHeader from '../../../constants/ReportHeader';
import { useReactToPrint } from "react-to-print";
import { TransactionRpt } from '../../../helpers/models/Models';
import { useEffect, useRef, useState } from 'react';
import MahasulRptFormView from '../../../components/account/reports/mahasul_rpt/MahasulRptFormView';
import MahasulRptListView from '../../../components/account/reports/mahasul_rpt/MahasulRptListView';
import PrintMahasulRptListView from '../../../components/account/reports/mahasul_rpt/PrintMahasulRptListView';

const AccountMahasulReportListView = ({ setIconsButton }: { setIconsButton: any }) => {
    const { isOpen, toggleSidebar, closeSidebar } = useSidebar('mahasul_rtp');
    const [onMahasulReport, setOnMahasulReport] = useState<TransactionRpt[]>([]);
    const componentListRef = useRef<HTMLDivElement | null>(null);

    const handlePrintCard = useReactToPrint({
        content: () => componentListRef.current!,
    });

    useEffect(() => {
        setIconsButton(<CircleBtn onClick={handlePrintCard} />);
        return () => setIconsButton(null);
    }, []);

    useEffect(() => {
        if (!isOpen) {
            toggleSidebar();
        }
    }, [isOpen, toggleSidebar]);
    return (
        <>
            <SidebarOpen onClick={toggleSidebar} />
            <ReportDrawer header={<ReportHeader label='Mahasul Report' />} open={isOpen} onClose={closeSidebar}>
                <MahasulRptFormView setOnMahasulReport={setOnMahasulReport} />
            </ReportDrawer>
            <MahasulRptListView onMahasulReport={onMahasulReport} />
            <div className='hidden'>
                <div ref={componentListRef}>
                    <PrintMahasulRptListView onMahasulReport={onMahasulReport} />
                </div>
            </div>
        </>
    );
}

export default AccountMahasulReportListView;
